// extracted by mini-css-extract-plugin
module.exports = {"Table":"Table_Table__3T7E0","block":"Table_block__1Hglg"};